module.exports = __webpack_public_path__ + "img/dianchi-40.efbc6c52.png";